import {
  ALL_MISSED_DAY_SCORE_SOURCES as SharedAllMissedDayScoreSources,
  MISSED_DAY_SCORE_SOURCES as SharedMissedDayScoreSources,
} from 'shared/dist/types/MissedDayAllowance';

export type { MissedDayAllowance, MissedDayScoreSource } from 'shared/dist/types/MissedDayAllowance';

export const MISSED_DAY_SCORE_SOURCES = SharedMissedDayScoreSources;
export const ALL_MISSED_DAY_SCORE_SOURCES = SharedAllMissedDayScoreSources;
